/* ASTREK ski-personality quiz data — port of lib/content.ts.
   24 questions, 4 options each; every option scores +2 for one of 8
   archetypes. Highest total wins; ties go to the archetype that was
   triggered most recently. */
(function () {
  'use strict';

  var archetypes = {
    influencer: {
      key: 'influencer',
      name: 'The Après-Ski Influencer',
      tagline: 'Your best run might have been the one you posted.',
      color: '#e9a23b',
      /* sampled from the card artwork; used for the 3D edge */
      edgeColor: '#eea948'
    },
    safety: {
      key: 'safety',
      name: 'The Safety CEO',
      tagline: 'Your risk assessment has a risk assessment.',
      color: '#5b6166',
      /* sampled from the card artwork; used for the 3D edge */
      edgeColor: '#46a2e8'
    },
    survivor: {
      key: 'survivor',
      name: 'The Hot Chocolate Survivor',
      tagline: 'You conquered the mountain. Mostly from the lodge.',
      color: '#c2410c',
      /* sampled from the card artwork; used for the 3D edge */
      edgeColor: '#bb4848'
    },
    snowball: {
      key: 'snowball',
      name: 'The Human Snowball',
      tagline: 'Gravity knows your name.',
      color: '#7ee7ec',
      /* matches the card artwork; used for the 3D edge */
      edgeColor: '#4c72eb'
    },
    gear: {
      key: 'gear',
      name: 'The Gear Philosopher',
      tagline: "Your skiing isn't the problem. Your setup is. Obviously.",
      color: '#8b5cf6',
      /* sampled from the card artwork; used for the 3D edge */
      edgeColor: '#f2db44'
    },
    police: {
      key: 'police',
      name: 'The Technique Police',
      tagline: 'Every run comes with a free coaching session.',
      color: '#3f3f46',
      /* sampled from the card artwork; used for the 3D edge */
      edgeColor: '#fee953'
    },
    director: {
      key: 'director',
      name: 'The Slope Director',
      tagline: 'No footage, no proof.',
      color: '#ff4e16',
      /* sampled from the card artwork; used for the 3D edge */
      edgeColor: '#ae62ea'
    },
    lineHunter: {
      key: 'lineHunter',
      name: 'The Line Hunter',
      tagline: 'The suggested runs are just suggestions.',
      color: '#00c3ce',
      /* sampled from the card artwork; used for the 3D edge */
      edgeColor: '#ffffff'
    }
  };

  var questions = [
    {
      text: '30cm of fresh snow falls overnight. You wake up and see the report. What do you do first?',
      options: [
        { key: 'A', label: 'A. Find the untouched snow.', archetype: 'lineHunter' },
        { key: 'B', label: 'B. Check avalanche conditions.', archetype: 'safety' },
        { key: 'C', label: 'C. Wonder if my skis are ready.', archetype: 'gear' },
        { key: 'D', label: 'D. Charge every camera.', archetype: 'director' }
      ]
    },
    {
      text: 'The night before your biggest ski day of the trip. What are you doing?',
      options: [
        { key: 'A', label: 'A. Sleeping early. Everything is ready.', archetype: 'safety' },
        { key: 'B', label: 'B. Watching ski videos and planning shots.', archetype: 'director' },
        { key: 'C', label: 'C. Still texting the group at midnight.', archetype: 'influencer' },
        { key: 'D', label: "D. Checking tomorrow's snow report again.", archetype: 'lineHunter' }
      ]
    },
    {
      text: 'You arrive at the resort before the lifts open.',
      options: [
        { key: 'A', label: "A. I woke up late, but I'm still going.", archetype: 'snowball' },
        { key: 'B', label: 'B. Coffee first. The mountain can wait.', archetype: 'survivor' },
        { key: 'C', label: 'C. Check my gear one more time.', archetype: 'gear' },
        { key: 'D', label: 'D. Find the best photo spot.', archetype: 'influencer' }
      ]
    },
    {
      text: 'A kid half your size just passed you.',
      options: [
        { key: 'A', label: 'A. How is that kid so fast?', archetype: 'snowball' },
        { key: 'B', label: 'B. That turn needs fixing.', archetype: 'police' },
        { key: 'C', label: 'C. My skis are definitely part of the problem.', archetype: 'gear' },
        { key: 'D', label: 'D. Please tell me nobody filmed that.', archetype: 'influencer' }
      ]
    },
    {
      text: 'Your friend asks: “Where should we ski today?”',
      options: [
        { key: 'A', label: 'A. I know a spot nobody talks about.', archetype: 'lineHunter' },
        { key: 'B', label: "B. Let's pick something everyone can handle.", archetype: 'safety' },
        { key: 'C', label: 'C. I just need a good place to recover after.', archetype: 'survivor' },
        { key: 'D', label: 'D. Somewhere we can take some good photos.', archetype: 'influencer' }
      ]
    },
    {
      text: 'Someone challenges you to hit a small jump.',
      options: [
        { key: 'A', label: "A. LET'S GO!", archetype: 'snowball' },
        { key: 'B', label: 'B. Watch someone else try first.', archetype: 'police' },
        { key: 'C', label: "C. I'll film it.", archetype: 'director' },
        { key: 'D', label: 'D. Nope. I like my bones.', archetype: 'safety' }
      ]
    },
    {
      text: 'You finally land a perfect run.',
      options: [
        { key: 'A', label: 'A. Replay it and figure out what worked.', archetype: 'police' },
        { key: 'B', label: 'B. Find a harder one next.', archetype: 'lineHunter' },
        { key: 'C', label: 'C. That new setup worked.', archetype: 'gear' },
        { key: 'D', label: 'D. Get the footage before anyone leaves.', archetype: 'director' }
      ]
    },
    {
      text: 'Your legs are completely dead halfway through the day.',
      options: [
        { key: 'A', label: 'A. Time for a serious lodge break.', archetype: 'survivor' },
        { key: 'B', label: 'B. My body has officially resigned.', archetype: 'snowball' },
        { key: 'C', label: 'C. Maybe my boots are the issue.', archetype: 'gear' },
        { key: 'D', label: "D. Let's figure out what went wrong.", archetype: 'police' }
      ]
    },
    {
      text: 'You choose a ski resort for your next trip. What matters most?',
      options: [
        { key: 'A', label: 'A. Snow quality and terrain.', archetype: 'lineHunter' },
        { key: 'B', label: 'B. Safety, facilities, and reliability.', archetype: 'safety' },
        { key: 'C', label: 'C. Restaurants and mountain atmosphere.', archetype: 'survivor' },
        { key: 'D', label: 'D. Places worth filming.', archetype: 'director' }
      ]
    },
    {
      text: 'Your helmet could show one line about you. What is it?',
      options: [
        { key: 'A', label: "A. I'm leading the uncertain way.", archetype: 'snowball' },
        { key: 'B', label: 'B. Give me a shot!', archetype: 'director' },
        { key: 'C', label: 'C. Safety check completed.', archetype: 'safety' },
        { key: 'D', label: "D. Sorry, I'm already off to the next line.", archetype: 'lineHunter' }
      ]
    },
    {
      text: 'Your friend sends you a video of your skiing.',
      options: [
        { key: 'A', label: 'A. Delete the bad angles.', archetype: 'influencer' },
        { key: 'B', label: 'B. Watch it frame by frame.', archetype: 'police' },
        { key: 'C', label: 'C. My skis are soooo cool!', archetype: 'gear' },
        { key: 'D', label: "D. This edit? I'd do it better.", archetype: 'director' }
      ]
    },
    {
      text: 'Lunch time in the mountains. Your plan?',
      options: [
        { key: 'A', label: 'A. Ten minutes. Back skiing.', archetype: 'lineHunter' },
        { key: 'B', label: 'B. A proper meal. We earned it.', archetype: 'survivor' },
        { key: 'C', label: 'C. Whatever keeps me alive.', archetype: 'snowball' },
        { key: 'D', label: 'D. Find somewhere with a view.', archetype: 'influencer' }
      ]
    },
    {
      text: 'You see a sign: “Closed Area. Do Not Enter.”',
      options: [
        { key: 'A', label: 'A. Turn around immediately.', archetype: 'safety' },
        { key: 'B', label: 'B. Film the whole situation.', archetype: 'director' },
        { key: 'C', label: 'C. Wonder what is behind it.', archetype: 'lineHunter' },
        { key: 'D', label: 'D. Already crossed it.', archetype: 'snowball' }
      ]
    },
    {
      text: "Your friend says: “I don't know why I ski so badly.”",
      options: [
        { key: 'A', label: "A. It's probably the gear problem.", archetype: 'gear' },
        { key: 'B', label: "B. Let me tell you exactly what's wrong.", archetype: 'police' },
        { key: 'C', label: 'C. Maybe we need a snack break.', archetype: 'survivor' },
        { key: 'D', label: "D. Don't worry. Everyone falls.", archetype: 'snowball' }
      ]
    },
    {
      text: 'Bluebird day. Fresh snow. Everyone knows this is the day.',
      options: [
        { key: 'A', label: 'A. I need a photo before I ruin my outfit.', archetype: 'influencer' },
        { key: 'B', label: 'B. Finally, a good excuse to take it slow.', archetype: 'survivor' },
        { key: 'C', label: 'C. Everyone better ski again, I missed the shot.', archetype: 'director' },
        { key: 'D', label: 'D. Lunch can wait. The snow cannot.', archetype: 'lineHunter' }
      ]
    },
    {
      text: 'Your skis could talk. What would they say?',
      options: [
        { key: 'A', label: 'A. Please stop blaming me.', archetype: 'snowball' },
        { key: 'B', label: 'B. We need to be tuned!', archetype: 'gear' },
        { key: 'C', label: 'C. You keep making the same mistake.', archetype: 'police' },
        { key: 'D', label: 'D. Finally, someone found the right line.', archetype: 'lineHunter' }
      ]
    },
    {
      text: 'After skiing all day, you return to your hotel.',
      options: [
        { key: 'A', label: "A. Review today's best turns.", archetype: 'police' },
        { key: 'B', label: "B. Check tomorrow's weather and conditions.", archetype: 'safety' },
        { key: 'C', label: 'C. Post photos and reply to messages.', archetype: 'influencer' },
        { key: 'D', label: 'D. Find food immediately.', archetype: 'survivor' }
      ]
    },
    {
      text: 'Your friend wants to try a harder run.',
      options: [
        { key: 'A', label: "A. Let's make sure everyone is ready.", archetype: 'safety' },
        { key: 'B', label: 'B. Is this worth filming?', archetype: 'director' },
        { key: 'C', label: 'C. Wait, your technique first.', archetype: 'police' },
        { key: 'D', label: 'D. Worst case, we get a funny story.', archetype: 'snowball' }
      ]
    },
    {
      text: 'Your new ski gear arrives at home.',
      options: [
        { key: 'A', label: 'A. Read reviews… again.', archetype: 'gear' },
        { key: 'B', label: "B. Check if it's as comfortable as when I tried it.", archetype: 'survivor' },
        { key: 'C', label: 'C. Take photos before touching anything.', archetype: 'influencer' },
        { key: 'D', label: 'D. Film the unboxing. Obviously.', archetype: 'director' }
      ]
    },
    {
      text: 'The mountain is crowded today.',
      options: [
        { key: 'A', label: 'A. Follow the crowd and hope for the best.', archetype: 'snowball' },
        { key: 'B', label: 'B. Stay careful. Too many people today.', archetype: 'safety' },
        { key: 'C', label: 'C. Wow… none of these turns are standard.', archetype: 'police' },
        { key: 'D', label: 'D. Lie back at the lodge and enjoy the comfort.', archetype: 'survivor' }
      ]
    },
    {
      text: 'You are trying your first black run.',
      options: [
        { key: 'A', label: 'A. I trained until I was ready.', archetype: 'police' },
        { key: 'B', label: "B. Someone said “you'll be fine.”", archetype: 'snowball' },
        { key: 'C', label: 'C. I checked everything before going.', archetype: 'safety' },
        { key: 'D', label: 'D. The right gear gave me confidence.', archetype: 'gear' }
      ]
    },
    {
      text: 'Your ski day is almost over.',
      options: [
        { key: 'A', label: 'A. One more run until the chair stops.', archetype: 'lineHunter' },
        { key: 'B', label: 'B. Find the perfect final shot.', archetype: 'director' },
        { key: 'C', label: 'C. Fix one last technique issue.', archetype: 'police' },
        { key: 'D', label: 'D. Celebrate with food and drinks.', archetype: 'survivor' }
      ]
    },
    {
      text: 'You are planning a ski trip with friends.',
      options: [
        { key: 'A', label: 'A. Pick the mountain with the best snow.', archetype: 'lineHunter' },
        { key: 'B', label: 'B. Make sure everyone has fun.', archetype: 'safety' },
        { key: 'C', label: 'C. Find the best gear shops nearby.', archetype: 'gear' },
        { key: 'D', label: 'D. Find the best places to film.', archetype: 'director' }
      ]
    },
    {
      text: 'After the trip, what do you remember most?',
      options: [
        { key: 'A', label: 'A. The ridiculous moments nobody planned.', archetype: 'snowball' },
        { key: 'B', label: 'B. The moments everyone shared.', archetype: 'influencer' },
        { key: 'C', label: 'C. The things I improved.', archetype: 'police' },
        { key: 'D', label: 'D. The food, drinks, and mountain life.', archetype: 'survivor' }
      ]
    }
  ];

  /* Card backgrounds, cycled in order across the question cards.
     `base` is the reference color used to derive the number tint.
     bgAsset entries are resolved to CSS by astrek-lab.js using the
     asset URLs from the section's config JSON. */
  var cardBackgrounds = [
    { bg: 'linear-gradient(180deg, #bbedf1 -0.53%, #00c3ce 101.88%)', base: '#00c3ce' },
    { bgAsset: 'bgA1', bgColor: '#a4a3a4', base: '#a4a3a4' },
    { bgAsset: 'bgA2', bgColor: '#8c44ff', base: '#8c44ff' },
    { bg: '#a4a3a4', base: '#a4a3a4' },
    { bg: '#f74e10', base: '#f74e10' },
    { bg: '#585758', base: '#585758' }
  ];

  var cardFront = {
    tags: ['Reimagine Skiing'],
    site: 'www.astrek.ai'
  };

  var logoSvg =
    '<svg viewBox="0 0 194 28" fill="none" class="ax-logo" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M64.39 0.0100098H63.61H50.49C44.98 0.0100098 40.16 3.74008 38.78 9.08008L55.96 21.1101C57.1 21.9101 56.54 23.7002 55.14 23.7002H35.42L34.55 27.0601H47.84H54.42C60 27.0601 64.87 23.2901 66.26 17.8801L49.27 5.9502C48.13 5.1502 48.7 3.36011 50.09 3.36011H66.3L67.17 0H64.38L64.39 0.0100098Z" fill="currentColor"/>' +
    '<path d="M154.61 15.4202L155.48 12.05H140.57L142.81 3.37012H160.15L161.02 0.0100098H135.04L127.79 27.0701H132.66H136.69H154.03L154.9 23.7102H137.56L139.7 15.4202H154.61Z" fill="currentColor"/>' +
    '<path d="M29.23 0.0100098H19.3C12.05 0.0100098 5.71002 4.92019 3.90002 11.9402L0 27.0701H9.17004L9.95001 24.0601C11.79 18.5001 18.2 17.5001 20.16 17.0801C22.57 16.5601 24.12 16.23 25.11 16.01L22.26 27.0701H31.21L38.41 0.0100098H29.24H29.23ZM25.7001 13.6802L12.23 15.2002L13.4401 10.52C14.5301 6.31002 18.32 3.38013 22.66 3.38013H28.36L25.7001 13.6902V13.6802Z" fill="currentColor"/>' +
    '<path d="M129.01 7.55005L130.96 0.0100098H121.79H111.36H102.4L95.21 27.0701H104.38L106.99 16.9602L113.3 16.27L115.56 27.0701H124.55L121.91 15.0901C125.36 13.9701 128.08 11.16 129.01 7.54004V7.55005ZM120.8 6.40015C119.18 12.3801 112.54 13.4201 110.53 13.8601C109.5 14.0801 108.52 14.2702 107.65 14.4302L110.5 3.38013H121.6C120.81 6.46013 120.81 6.41015 120.81 6.40015H120.8Z" fill="currentColor"/>' +
    '<path d="M99.6801 0.0100098H69.52L68.65 3.37012H79.71C79.71 3.37012 79.68 3.43998 79.67 3.47998L73.34 27.1602H82.52L88.74 3.37012H98.8101L99.6801 0.0100098Z" fill="currentColor"/>' +
    '<path d="M193.03 0.0100098H184.29L177.05 12.76L169.6 13.5801L173.1 0.0100098H164.46L158.09 23.7102L157.22 27.0701H163.97H166.12L167.5 21.7102C169.54 17.0202 175.03 15.98 177.16 15.55L179.55 26.98H188.45L185.48 13.52L193.03 0.0100098Z" fill="currentColor"/>' +
    '</svg>';

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Numbered question card artwork — port of components/QuizCardArt.tsx.
     Sized with em units so it scales with the container's font-size. */
  function cardArtHTML(opts) {
    var teaser = opts.teaser || '';
    var sizeClass =
      teaser.length > 70
        ? 'ax-qcard__teaser--s'
        : teaser.length > 44
          ? 'ax-qcard__teaser--m'
          : 'ax-qcard__teaser--l';
    var html = '<div class="ax-qcard" style="background:' + escapeHtml(opts.bg) + '">';
    if (opts.num) {
      html +=
        '<span class="ax-qcard__num" style="color:color-mix(in srgb, ' +
        escapeHtml(opts.base) +
        ' 50%, black)">' +
        escapeHtml(opts.num) +
        '</span>';
    }
    html +=
      '<p class="ax-qcard__teaser ' +
      sizeClass +
      (opts.num ? ' ax-qcard__teaser--after-num' : '') +
      '">' +
      escapeHtml(teaser) +
      '</p>';
    html += '<p class="ax-qcard__tags">' + escapeHtml(cardFront.tags.join('\n')) + '</p>';
    html +=
      '<div class="ax-qcard__foot">' +
      /* references the shared <symbol> rendered once by astrek-logo-symbol.liquid */
      '<svg viewBox="0 0 194 28" class="ax-logo" aria-hidden="true"><use href="#ax-logo-symbol"/></svg>' +
      '<span class="ax-qcard__site">' +
      escapeHtml(cardFront.site) +
      '</span></div>';
    html += '</div>';
    return html;
  }

  window.AstrekQuiz = {
    archetypes: archetypes,
    questions: questions,
    cardBackgrounds: cardBackgrounds,
    cardFront: cardFront,
    logoSvg: logoSvg,
    escapeHtml: escapeHtml,
    cardArtHTML: cardArtHTML
  };
})();
